import * as types from './mutations-types';

const initialState = {
  iframeReturnErrors: [],
  iframeReturnSuccess: null,
  redirectUrl: null,
  cardData: {},
  adyenIdentifyResponse: null,
};

const actions = {
  setErrors({ dispatch, commit }, errors) {
    commit(types.CHECKOUT_SET_US_PAYMENT_IFRAME_ERROR, errors);
    dispatch('setReturnSuccess', false);
  },

  setSuccess({ dispatch, state, commit }, token) {
    commit(types.CHECKOUT_FILL_PAYMENT_DATA, { ...state.cardData, token });
    dispatch('setReturnSuccess', true);
  },

  setReturnSuccess({ commit }, status) {
    commit(types.CHECKOUT_SET_IFRAME_RETURN_SUCCESS, status);
  },

  resetState({ commit }) {
    commit(types.CHECKOUT_SET_US_PAYMENT_IFRAME_ERROR, []);
    commit(types.CHECKOUT_SET_IFRAME_RETURN_SUCCESS, null);
  },

  prefillPaymentData({ commit }, data) {
    commit(types.CHECKOUT_FILL_PAYMENT_DATA, data);
  },

  setIdentifyResponse({ commit }, response) {
    commit(types.CHECKOUT_SET_ADYEN_IDENTIFY_RESPONSE, response);
  },

  setChallengeResponse({ commit }, response) {
    commit(types.CHECKOUT_SET_ADYEN_CHALLENGE_RESPONSE, response);
  },
};

const mutations = {
  [types.CHECKOUT_SET_US_PAYMENT_IFRAME_ERROR](state, errors) {
    state.iframeReturnErrors = errors;
  },

  [types.CHECKOUT_FILL_PAYMENT_DATA](state, data) {
    state.cardData = data;
  },

  [types.CHECKOUT_SET_IFRAME_RETURN_SUCCESS](state, status) {
    state.iframeReturnSuccess = status;
  },

  [types.CHECKOUT_SET_ADYEN_IDENTIFY_RESPONSE](state, response) {
    state.adyenIdentifyResponse = response;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
